import UploadIcon from "@mui/icons-material/Upload";
import AddIcon from "@mui/icons-material/Add";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faUpload, faPlus } from "@fortawesome/fontawesome-free-solid";
import PageHeader from "../../../shared/components/common/PageHeader";

const UserManagementHeader = ({
  onBulkImport,
  onAddUser,
  useMUIcons = true,
}) => {
  return (
    <PageHeader
      title="User Management"
      subtitle="Manage users, roles, and delivery settings for your account."
    >
      {/* <button
        onClick={onBulkImport}
        className="flex items-center gap-1 sm:gap-2 px-3 sm:px-4 py-1.5 sm:py-2 border border-gray-300 rounded-lg text-sm font-medium text-gray-700 hover:bg-gray-50 transition-colors"
      >
        {useMUIcons ? (
          <UploadIcon fontSize="small" />
        ) : (
          <FontAwesomeIcon icon={faUpload} className="text-sm" />
        )}
        <span>BULK IMPORT</span>
      </button> */}
      <button
        onClick={onAddUser}
        className="flex items-center gap-1 sm:gap-2 px-3 sm:px-4 py-1.5 sm:py-2 bg-primary text-white rounded-lg text-xs sm:text-sm font-medium hover:bg-primary/90 transition-colors"
      >
        {useMUIcons ? (
          <AddIcon fontSize="small" />
        ) : (
          <FontAwesomeIcon icon={faPlus} className="text-sm" />
        )}
        <span>ADD USER</span>
      </button>
    </PageHeader>
  );
};

export default UserManagementHeader;
